// import React, { useState, useEffect } from 'react';
// import { Modal, Form, Input, Select, DatePicker, Button, message, Typography, Col, Row } from 'antd';
// import axios from '../../../utils/BasicAuthAPI';
import CreateAndEditAudit from "./CreateAndEditAudit";
// import { useParams, useLocation } from "react-router-dom";
// import queryString from "query-string";
// import moment from "moment";

// const CreateAndEditAuditPage = (props) => {
//     const [visible, setVisible] = useState(false);
//     const [defaultData, setDefaultData] = useState(null);
//     let { auditId } = useParams();

//     const sendBackData = (data) => {
//         setVisible(false);
//         props.modelCloseHandler(data, true);
//     }

//     const handleCancel = () => {
//         setVisible(false);
//         props.modelCloseHandler([], false);
//     };

//     let location = useLocation();
//     const params = queryString.parse(location.search);

//     useEffect(() => {
//         console.log("changes");
//         if (params.LID && params.TYP && params.SUBTYP && params.Status && params.Auditor && params.Auditee && params.Team && params.AuditDt) {
//             console.log({ ...params, Team: params.Team.split(","), AuditDt: params.AuditDt ? moment(params.AuditDt, "YYYY/MM/DD") : null, id: auditId });
//             setDefaultData({ ...params, Team: params.Team.split(","), AuditDt: params.AuditDt ? moment(params.AuditDt, "YYYY/MM/DD") : null, id: auditId });
//         }
//     }, [location.search])

//     // useEffect(() => {
//     //     if (props.visible) {
//     //         setVisible(props.visible)
//     //     }
//     // }, [props]);
//     return (
//         <React.Fragment>
//             <CreateAndEditAudit defaultData={defaultData} isEdit={(defaultData) ? true : false} />
//         </React.Fragment>

//     );
// };

// export default CreateAndEditAuditPage;

import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
} from "antd";
import axios from "../../../utils/BasicAuthAPI";
// import SearchAudit from "./SearchAudit";
import moment from "moment";

const { Text, Link } = Typography;

const CreateAndEditAuditPage = (props) => {
  const [visible, setVisible] = useState(true);
  props.setPageHeader("Audit");
  const sendBackData = (editData) => {
    setVisible(false);
    props.modelCloseHandler(editData);
  };

  const handleCancel = () => {
    setVisible(false);
    props.modelCloseHandler(null, props.editData);
  };

  useEffect(() => {
    if (props.visible) {
      setVisible(props.visible);
    }
  }, [props]);
  return (
    <React.Fragment>
      <Modal
        title={"Create Audit"}
        open={visible}
        onOk={handleCancel}
        onCancel={handleCancel}
        className={"ThemeModal"}
        // width={960}
      >
        <CreateAndEditAudit
          sendBackData={sendBackData}
          defaultValues={props.editData}
          AuditLines={props.AuditLines}
          AuditType={props.AuditType}
          AuditUsers={props.AuditUsers}
          isEdit={props.editData ? true : false}
        />
      </Modal>
    </React.Fragment>
  );
};

export default CreateAndEditAuditPage;
